import React, { useState } from 'react';
import { 
    Table, Button, Card, Space, Form, Input, Select, 
    Typography, Tag, Drawer, message, Popconfirm
} from 'antd';
import {
    SearchOutlined, ReloadOutlined, DownloadOutlined
} from '@ant-design/icons';
const { Title, Text, Link } = Typography;

const { Option } = Select;

const VendorManage = () => {
    const [drawerVisible, setDrawerVisible] = useState(false);
    const [editingItem, setEditingItem] = useState(null);
    const [form] = Form.useForm();
    const [searchForm] = Form.useForm();

    // 模拟已有卡商定义列表 (供下拉选择)
    const VENDOR_DEFINITIONS = [
        { id: '1', name: '麦联宝' },
        { id: '2', name: '万物互联电信(zweitx)' },
        { id: '3', name: '桔子智联' },
        { id: '4', name: '汇云宁波电信' },
    ];

    // 模拟卡商管理列表数据
    const [data] = useState([
        { id: '1', name: '汇云宁波电信', domain: 'http://175.27.235.33:19028', buyUrl: '', verifyStatus: 'pass', lastVerifyTime: '2026-02-28 10:51:15' },
        { id: '2', name: '测试验证通过', domain: 'http://175.27.235.33:19028', buyUrl: '', verifyStatus: 'pass', lastVerifyTime: '2026-01-13 14:28:40' },
        { id: '3', name: '测试卡商110', domain: 'https://www.baidu.com', buyUrl: '', verifyStatus: 'fail', lastVerifyTime: '2026-01-07 17:26:14' },
        { id: '4', name: '测试卡商119', domain: 'https://www.baidu.com4', buyUrl: '', verifyStatus: 'fail', lastVerifyTime: '2026-02-28 10:52:09' },
        { id: '5', name: '测试卡商118', domain: 'https://www.baidu.com4', buyUrl: '', verifyStatus: 'none', lastVerifyTime: '-' },
    ]);

    const handleConfigure = (record = null) => {
        setEditingItem(record);
        if (record) {
            form.setFieldsValue({
                vendorId: record.name, // 实际开发应为 ID
                domain: record.domain,
                buyUrl: record.buyUrl
            });
        } else {
            form.resetFields();
        }
        setDrawerVisible(true);
    };

    const columns = [
        { title: '序号', dataIndex: 'id', key: 'id', width: 70, align: 'center' },
        { title: '卡商名称', dataIndex: 'name', key: 'name', width: 150 },
        { title: '接口域名', dataIndex: 'domain', key: 'domain', width: 220, ellipsis: true },
        { title: '购买地址', dataIndex: 'buyUrl', key: 'buyUrl', width: 180, render: (t) => t || '-' },
        { title: '签名配置', key: 'signConfig', width: 100, render: () => <Link>查看</Link> },
        { 
            title: '签名验证', 
            dataIndex: 'verifyStatus', 
            key: 'verifyStatus',
            width: 100,
            render: (s) => {
                if (s === 'pass') return <Tag color="success">通过</Tag>;
                if (s === 'fail') return <Tag color="error">未通过</Tag>;
                return <Tag color="default">待验证</Tag>;
            }
        },
        { title: '最后验证时间', dataIndex: 'lastVerifyTime', key: 'lastVerifyTime', width: 180 },
        { 
            title: '操作', 
            key: 'action',
            fixed: 'right',
            width: 220,
            render: (_, record) => (
                <Space>
                    <Button type="link" size="small" onClick={() => handleConfigure(record)}>修改配置</Button>
                    <Button type="link" size="small">验证签名</Button>
                    <Popconfirm title="确定删除吗？" okButtonProps={{ danger: true }}>
                        <Button type="link" danger size="small">删除</Button>
                    </Popconfirm>
                </Space>
            )
        },
    ];

    return (
        <div style={{ padding: '24px' }}>
            {/* 筛选栏 */}
            <div style={{ background: '#fff', padding: '16px 24px', marginBottom: 16, borderRadius: 8 }}>
                <Form layout="inline" form={searchForm}>
                    <Form.Item label="4G卡商" name="vendor">
                        <Input placeholder="请输入" style={{ width: 200 }} />
                    </Form.Item>
                    <Form.Item>
                        <Space>
                            <Button type="primary" icon={<SearchOutlined />}>查询</Button>
                            <Button icon={<ReloadOutlined />} onClick={() => searchForm.resetFields()}>重置</Button>
                        </Space>
                    </Form.Item>
                </Form>
            </div>

            {/* 表格卡片 */}
            <Card bordered={false} bodyStyle={{ padding: '0 24px 24px' }}>
                <div style={{ padding: '16px 0' }}>
                    <Button type="primary" onClick={() => handleConfigure()}>配置卡商</Button>
                </div>
                <Table 
                    columns={columns} 
                    dataSource={data} 
                    rowKey="id" 
                    scroll={{ x: 1200 }}
                    pagination={{ showSizeChanger: true, showTotal: (total) => `共${total}条记录` }} 
                />
            </Card>

            {/* 配置抽屉 */}
            <Drawer
                title={editingItem ? '修改卡商配置' : '卡商配置'}
                width={650}
                onClose={() => setDrawerVisible(false)}
                open={drawerVisible}
                destroyOnClose
                footer={
                    <div style={{ textAlign: 'right', padding: '10px 16px' }}>
                        <Button onClick={() => setDrawerVisible(false)} style={{ marginRight: 8 }}>取消</Button>
                        <Button type="primary" onClick={() => {
                            message.success('配置已保存');
                            setDrawerVisible(false);
                        }}>确定</Button>
                    </div>
                }
            >
                <Form form={form} layout="vertical">
                    {/* 卡商名称选择 */}
                    <Form.Item 
                        label="选择卡商" 
                        name="vendorId" 
                        rules={[{ required: true, message: '请选择卡商' }]}
                    >
                        <Select placeholder="请选择">
                            {VENDOR_DEFINITIONS.map(v => <Option key={v.id} value={v.name}>{v.name}</Option>)}
                        </Select>
                    </Form.Item>

                    {/* 开发者接入 */}
                    <div style={{ marginBottom: 24 }}>
                        <Title level={4} style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                            <div style={{ width: 8, height: 8, background: '#1890ff', borderRadius: '50%' }} />
                            开发者接入
                        </Title>
                        <div style={{ background: '#f0f7ff', padding: '16px', borderRadius: 8, marginTop: 12 }}>
                            <div style={{ marginBottom: 8 }}>1、鹤梦平台定义一套通用业务系统需要的接口：<Link icon={<DownloadOutlined />}>立即下载</Link></div>
                            <div style={{ marginBottom: 8 }}>2、下载查看鹤梦平台所需4G相关接口</div>
                            <div style={{ color: '#8c8c8c', paddingLeft: 20, marginBottom: 8 }}>
                                2.1、企业开发者先对接卡商API以满足鹤梦平台所需接口相关内容（套餐、流量查询等）
                            </div>
                            <div style={{ color: '#8c8c8c', paddingLeft: 20, marginBottom: 16 }}>
                                2.2、配置域名：企业开发者满足鹤梦平台接口（文档）的所属域名
                            </div>
                            <Form.Item 
                                label={<Text strong><span style={{ color: '#ff4d4f' }}></span> 配置域名</Text>} 
                                name="domain" 
                                rules={[{ required: true, message: '请填写配置域名' }]}
                            >
                                <Input placeholder="请填写" />
                            </Form.Item>
                        </div>
                    </div>

                    {/* 购买配置 */}
                    <div style={{ marginBottom: 24 }}>
                        <Title level={4} style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                            <div style={{ width: 8, height: 8, background: '#1890ff', borderRadius: '50%' }} />
                            购买配置
                        </Title>
                        <div style={{ background: '#f5f5f5', padding: '16px', borderRadius: 8, marginTop: 12 }}>
                            <div style={{ fontWeight: 500, marginBottom: 8 }}>此项为非必填项：</div>
                            <div style={{ marginBottom: 4 }}>1、不填写可在鹤梦平台公版，或任意App内完成4G流量购买</div>
                            <div style={{ marginBottom: 16 }}>2、填写将跳转到已填写的地址下购买4G套餐</div>
                            <Form.Item label="购买地址" name="buyUrl">
                                <Input placeholder="请填写，以https://开头" />
                            </Form.Item>
                        </div>
                    </div>

                    {/* 完成配置 */}
                    <div>
                        <Title level={4} style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                            <div style={{ width: 8, height: 8, background: '#1890ff', borderRadius: '50%' }} />
                            完成配置
                        </Title>
                        <div style={{ background: '#f5f5f5', padding: '16px', borderRadius: 8, marginTop: 12, color: '#8c8c8c' }}>
                            配置完成后，为保证企业4G相关接口安全，系统将生成Key和Secret，用以请求接口验签
                        </div>
                    </div>
                </Form>
            </Drawer>
        </div>
    );
};

export default VendorManage;
